import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
import 'reframe.js/dist/jquery.reframe.min'
import 'jquery-match-height/jquery.matchHeight'
import 'what-input'

import './selects'
import './ie11'
import './header'
import './content'
import './load-more'
import './front-page'


objectFitImages()

jQuery.fancybox.defaults.animationEffect = 'fade'
// jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]

jQuery('.content iframe:not(.content .no-resize iframe)').reframe()

jQuery(document).ready(function () {

    jQuery(".jaotama__window-opener.copylink").click(function(event){
        var $copiedElement = jQuery("<span>");
        $copiedElement.addClass('copied-link').text('Copied!');
        jQuery('.jaotama__window-opener.copylink').append($copiedElement);
        $copiedElement.fadeIn(300);
        $copiedElement.fadeOut(1500);
   });

})

if (jQuery('.woocommerce-product-gallery__wrapper').length > 0) {

    var $trp_gallery = jQuery('.woocommerce-product-gallery__carousel').flickity({
        cellSelector: '.woocommerce-product-gallery__image',
        //wrapAround: true,
        cellAlign: 'left',
        //groupCells: true,
        contain: true,
        freeScroll: true,
        autoPlay: false,
        draggable: false,
        pageDots: false,
        arrowShape: {
            x0: 30,
            x1: 55, y1: 30,
            x2: 65, y2: 30,
            x3: 40
        },
    })

    var flkty = $trp_gallery.data('flickity')

    var trpGalleryItems = []

    jQuery('.woocommerce-product-gallery__carousel a').each(function (index) {
        trpGalleryItems.push({ src: jQuery(this).attr('href'), type: 'image', opts: {} })
    })

    jQuery('.woocommerce-product-gallery__wrapper a').on('click', function (e) {
        e.preventDefault()
    })

    jQuery('.woocommerce-product-gallery__all-img img').on('click', function (event, pointer, cellElement, cellIndex) {

        if (!event.target)
            return

        var fancyItems = jQuery.fancybox.open(trpGalleryItems, { index: trp_gallery_get_index(jQuery(event.target.parentElement).attr('href')) })

    })

    $trp_gallery.on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex == 'number') {
            var len = flkty.cells.length;
            cellIndex = getClosestIndex(cellIndex, flkty.selectedIndex, len);
            cellIndex = getClosestIndex(cellIndex, flkty.selectedIndex, -len);
            $trp_gallery.flickity('select', cellIndex);
        }
    })

    $trp_gallery.on('select.flickity', function () {
        jQuery( '.woocommerce-product-gallery__all-img .woocommerce-product-gallery__image').hide()

        jQuery('.woocommerce-product-gallery__all-img .woocommerce-product-gallery__image').eq(flkty.selectedIndex).show()
    })

    function trp_gallery_get_index(url) {

        var index;

        trpGalleryItems.forEach(function (item, itemIndex) {
            if (item.src == url)
                index = itemIndex
        })

        return index

    }


    function getClosestIndex(index, selectedIndex, delta) {
        var deltaIndex = index + delta;
        return Math.abs(deltaIndex - selectedIndex) < Math.abs(index - selectedIndex) ? deltaIndex : index;
    }

    jQuery(document).on('keydown', function(event) {
        if (event.key == "Enter") {

            if(jQuery('.woocommerce-product-gallery__image--first>a').is(":focus")){
                // jQuery('.woocommerce-product-gallery__image--first>a').trigger('click')
                console.log(jQuery('.woocommerce-product-gallery__image--first>a').attr('href'))
                var firstLink = jQuery('.woocommerce-product-gallery__image--first>a')
                jQuery.fancybox.open(trpGalleryItems, { index: trp_gallery_get_index(firstLink.attr('href')) })
            }

        }
    });

}
